import { useEffect, useState } from "react";
import { getSessionId } from "../services/authService";
import { getLdsDrafts } from "../services/fhpService";

/**
 * Count of LDS offers in progress (!paid && !cancelled), same semantics as drafts table "בהליך".
 */
export function useOpenOffersCount(isAdmin, userId) {
  const [openOffersCount, setOpenOffersCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const fetchOpenOffers = async () => {
      try {
        const sessionID = await getSessionId();
        if (!sessionID) return;
        const response = await getLdsDrafts({
          sessionID,
          agent_id: isAdmin ? null : userId,
          count_only: true,
        });
        if (cancelled) return;
        const c = response?.data?.count?.open_lds_orders;
        const n =
          typeof c === "number" ? c : c != null ? parseInt(String(c), 10) : NaN;
        setOpenOffersCount(Number.isFinite(n) ? n : 0);
      } catch {
        if (!cancelled) setOpenOffersCount(0);
      }
    };
    fetchOpenOffers();
    const interval = setInterval(fetchOpenOffers, 60000);
    const onLdsChange = () => {
      fetchOpenOffers();
    };
    window.addEventListener("ldsDraftsChanged", onLdsChange);
    return () => {
      cancelled = true;
      clearInterval(interval);
      window.removeEventListener("ldsDraftsChanged", onLdsChange);
    };
  }, [isAdmin, userId]);

  return openOffersCount;
}
